import { Injectable } from '@angular/core';
import { MatDialog} from '@angular/material/dialog';
import { DialogdeletekaizenconfirmComponent } from '../dialogdeletekaizenconfirm/dialogdeletekaizenconfirm.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogDeleteService {

  constructor(private dialog : MatDialog) { }

  openDialog(){
    return this.dialog.open(DialogdeletekaizenconfirmComponent,{
      width:'40%',
    });
  }
}
